export const locale = {
    lang: "pt-BR",
    data: {
        BILLING: {
            TITLE: "Faturamento",
            LOADING: "Carregando...",
            SHOW_MORE: "Mostrar mais",
            INVOICE: "Nota Fiscal",
            BANK_SLIP: "Boleto Bancário",
            CREDIT_CARD: "Cartão de Crédito",
            PIX: "PIX",
            COUPON: "Cupom",
            REVIEW_NOTE: "Se a transação foi rejeitada pela operadora do cartão, tente realizar a compra novamente.",
            STATUS: {
                PENDING: "Pendente",
                BILLED: "Pago",
                EXTERNALLY_PAID: "Pago Externamente",
                CANCELED: "Cancelado",
                EXPIRED: "Expirado",
                DUE: "Vencido",
                REVIEW: "Necessário revisão"
            }
        }
    }
};